import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { BridgeSiteSettingsProps } from '~src/settings/bridge-settings/BridgeSiteSettings';
import { BridgeRemoteAgentsSectionBody } from '~src/settings/bridge-settings/sections/bridgeRemoteAgents/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from '~src/settings/bridge-settings/sections/bridgeRemoteAgents/BridgeRemoteAgentsSectionHeaders';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { multiPoolTableStyle, sectionExtraPaddingBottom } from './bridgeMultiPool/BridgeMultiPoolSection';

export function BridgeDefaultRemoteAgentsSection(props: BridgeSiteSettingsProps) {
  const title = FeatureFlags.edgeMultiPoolEnabled ? '' : Messages.siteRemoteAgentSettingsAgentsStatus();
  const tableClass = FeatureFlags.edgeMultiPoolEnabled
    ? `${multiPoolTableStyle} ${sectionExtraPaddingBottom}`
    : 'tb-static-grid-table';
  const defaultPoolRemovalAlert = FeatureFlags.edgeRoutingFiltersWithProjectsEnabled
    ? Messages.siteRemoteAgentSettingsDefaultPoolRemovalAlertWithRoutingRules()
    : Messages.siteRemoteAgentSettingsDefaultPoolRemovalAlert();
  return (
    <SettingsSection title={title}
      testId={'bridge-default-remote-agents-section'}>
      {FeatureFlags.edgeMultiPoolEnabled &&
        <div>
          <div className={'tb-data-grid-title-text'}>{Messages.siteRemoteAgentSettingsDefaultPool()}</div>
          <InlineAlertWidget testId={'default-pool-removal-alert'} type={InlineAlertType.Warning} style={{ marginBottom: 10 }}>
            {defaultPoolRemovalAlert}
          </InlineAlertWidget>
        </div>
      }
      <div>
        <table className={`${tableClass} tb-static-grid-table-remote-agents-width`}>
          <BridgeRemoteAgentsSectionHeaders isDefaultPool={true} />
          <BridgeRemoteAgentsSectionBody
            isDefaultPool={true}
            pools={props.edgePools.userDefinedPools}
            connectionStatuses={props.connectionStatuses}
            siteId={props.settings.id}
            refreshEdgePools={props.refreshEdgePools}
            agents={Object.values(props.edgePools.defaultPoolAgents)}
            hasLoadedEdgePools={props.hasLoadedEdgePools}
          />
        </table>
      </div>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const BridgeDefaultRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeDefaultRemoteAgentsSection',
  component: BridgeDefaultRemoteAgentsSection
});
